const blockUI = () => (
  <div className="box">
    <div className="spinner"></div>
  </div>
)

export default blockUI
